// Hand-drawn-style bingo balls as inline SVG.
// Wobbly stroke + rotational variance per ball give them a sketched feel.
// Usage: <BingoBall letter="B" number={7} color="red" size={64} rotate={-8} />

const COLORS = {
  red: { bg: "#FF3B30", text: "#fff", shadow: "#7A0A05" },
  green: { bg: "#0FB36A", text: "#fff", shadow: "#0B5430" },
  blue: { bg: "#1E88E5", text: "#fff", shadow: "#0F4F87" },
  yellow: { bg: "#FFD400", text: "#111", shadow: "#947600" },
  purple: { bg: "#8B5CF6", text: "#fff", shadow: "#4F2E96" },
  pink: { bg: "#EC4899", text: "#fff", shadow: "#8A1F58" },
};

export default function BingoBall({
  letter = "B",
  number = 7,
  color = "red",
  size = 64,
  rotate = 0,
  className = "",
  style = {},
}) {
  const c = COLORS[color] || COLORS.red;
  // Inner circle for highlight ("number window")
  const r = 50;
  const innerR = 28;

  return (
    <div
      className={`inline-block ${className}`}
      style={{ width: size, height: size, transform: `rotate(${rotate}deg)`, ...style }}
      aria-hidden="true"
    >
      <svg viewBox="0 0 110 110" width={size} height={size} style={{ overflow: "visible" }}>
        {/* Drop shadow disk (hand-drawn offset) */}
        <ellipse cx="58" cy="60" rx={r + 2} ry={r + 1} fill="#111" opacity="0.85" />
        {/* Main body */}
        <circle cx="55" cy="55" r={r} fill={c.bg} stroke="#111" strokeWidth="3" strokeLinejoin="round" />
        {/* Sketchy outline imperfection */}
        <path
          d={`M ${55 - r + 4} 50 q 10 -${r * 0.9} ${r * 1.8} 0 q 4 ${r * 0.6} -2 ${r * 0.9}`}
          stroke="#111"
          strokeWidth="1.2"
          fill="none"
          opacity="0.35"
        />
        {/* Inner number window */}
        <circle cx="55" cy="55" r={innerR} fill="#fff" stroke="#111" strokeWidth="2.5" />
        {/* Hand-drawn shadow under inner circle */}
        <path
          d={`M ${55 - innerR + 4} ${55 + innerR - 6} a ${innerR - 4} ${innerR - 4} 0 0 0 ${innerR * 2 - 8} 0`}
          stroke="#111"
          strokeWidth="1.3"
          fill="none"
          opacity="0.5"
        />
        {/* Letter + number */}
        <text
          x="55"
          y="62"
          textAnchor="middle"
          fontFamily="'Outfit', system-ui, sans-serif"
          fontWeight="900"
          fontSize="22"
          fill="#111"
          letterSpacing="-1"
        >
          {letter}
          <tspan fontSize="20" dx="1">{number}</tspan>
        </text>
        {/* Highlight reflection on top-left */}
        <ellipse cx="38" cy="32" rx="11" ry="6" fill="#fff" opacity="0.45" transform="rotate(-25 38 32)" />
      </svg>
    </div>
  );
}
